// removed by extract-text-webpack-plugin
module.exports = {"caption":"Caption__caption--1HFyq","bounce":"Caption__bounce--1g8o5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/Caption/Caption.css
// module id = ./src/components/Library/Caption/Caption.css
// module chunks = 4